<template>
    <div class="contenedor_gf">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-4">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Informe de Avance de Gestión Financiera</h1>
        </div>
        <div v-if="textoPrincipal">
            <!-- <p>{{ textoPrincipal }}</p> -->
            <p class="text-justify" v-html="textoPrincipal"></p>
        </div>
        <div class="col-12 my-3" v-if="listadoAnios">
            <px-select idSelect="tomo_IAGF" placeholder="Seleccione año a consultar" :options="listadoAnios" @KuramaSelect="anioSeleccionado = $event"></px-select>
        </div>
        <div v-if="anioSeleccionado">
            <h3>{{ anioSeleccionado.text }}</h3>
            <div class="row">
                <div class="col-md-9">
                    <h6>{{ txtSubtituloporAnio }}</h6>
                    <p class="text-justify" v-html="txtdescripcionInfAvanGestFinan"></p>
                </div>
                <div class="col-md-3 contenedor_img_cp"><img :src="urlServe + anioSeleccionado.img" alt="card image" class="img-fluid" width="210" height="263"/></div>
            </div>
            <div v-if="listadoDocumentosGestFinanPorAnio">
                <card-collapse-docs-nodos :sections="listadoDocumentosGestFinanPorAnio" :urlServe="urlServe"/>
            </div>
        </div>
        <span v-html="fecha_actualizacion"></span>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import AvanceGestFinan from "@/services/rendicionDeCuentas/informeAvanGestFinan/informeAvanGestFinan.js"
const _serviciosAvanGestFinan = new AvanceGestFinan();
import selectEjercicio from "../../../components/selectEjercicio.vue";
import botonAtras from '../../button-atras.vue';
import cardCollapseDocsNodos from '@/components/cardCollapseDocsNodos.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    mixins: [DateFormat],
    components: { selectEjercicio, botonAtras, cardCollapseDocsNodos},
    created(){
        window.scrollTo(0, 0);
        this.getInfoPrincipalGestFinan();
    },
    data(){
        return{
            dataInfoPrincipal: [],
            textoPrincipal: "",
            listadoAnios: [],
            anioSeleccionado: null,
            
            
            dataDocGestFinan: [],
            dataDocGestporAnio: [],
            txtSubtituloporAnio: "",
            txtdescripcionInfAvanGestFinan: null,

            listadoDocumentosGestFinanPorAnio: [],
            fecha_actualizacion: '',
        }
    },
    methods:{
        async getInfoPrincipalGestFinan(){
            try {
                const response = await _serviciosAvanGestFinan.getPrincipalGestionFinanciera(mapFun.gestionFinancieraInfoPrincipal);
                this.dataInfoPrincipal = response.data;
                this.fecha_actualizacion = this.DateFormatText(this.dataInfoPrincipal[this.dataInfoPrincipal.length-1].fecha_actualizacion)
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getTextoPrincipal() {
            try {
                let data_info = this.dataInfoPrincipal.filter(item => item.id === 0);
                this.textoPrincipal = data_info[0].descripcion;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getListadoAnios(){
            try {
                this.listadoAnios = this.dataInfoPrincipal.filter(item => item.id != 0);
                this.listadoAnios = this.listadoAnios.reverse();
                this.listadoAnios = this.listadoAnios.map(function (mapeoSelect) {
                    return {
                        id: mapeoSelect.id,
                        value: mapeoSelect.descripcion,
                        text: mapeoSelect.titulo,
                        img: mapeoSelect.recurso,
                    };
                });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getInfoDocsGestFinan(){
            try {
                let anio_selec = this.anioSeleccionado.value;
                let ruta = mapFun.gestionFinancieraInfoContenido;
                let ruta_completa = ruta+anio_selec+".json";
                const response = await _serviciosAvanGestFinan.getInfoDocsGestFinan(ruta_completa);
                this.dataDocGestporAnio = response.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getDescripcionGestFinanPorAnio() {
            try {
                let data_infoDoc = this.dataDocGestporAnio[0].contenido_anio;
                let data_txt = data_infoDoc.filter(item => item.id === 0);
                this.txtdescripcionInfAvanGestFinan = data_txt[0].descripcion;
                this.txtSubtituloporAnio = data_txt[0].titulo;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getListDocsGestFinanPorAnio() {
            try {
                let data_infoDoc = this.dataDocGestporAnio;
                let data_txt = data_infoDoc[0].contenido_anio.filter(item => item.id != 0);
                this.listadoDocumentosGestFinanPorAnio = data_txt;
                this.fecha_actualizacion = this.DateFormatText(this.listadoDocumentosGestFinanPorAnio[this.listadoDocumentosGestFinanPorAnio.length-1].fecha_actualizacion)
            } catch (error) {
                console.log('error', error.message);
            }
        },
    },
    watch:{
        dataInfoPrincipal(){
            if(this.dataInfoPrincipal){
                this.getTextoPrincipal();
                this.getListadoAnios();
            }
        },
        anioSeleccionado(){
            if(this.anioSeleccionado){
                this.getInfoDocsGestFinan();
            }
        },
        dataDocGestporAnio(){
            if(this.dataDocGestporAnio.length > 0){
                this.getDescripcionGestFinanPorAnio();
                this.getListDocsGestFinanPorAnio();
            }
        }

    }
}
</script>
<style scoped>
a{color: #212529;}
a:hover{color: #212529;}
.sub {
  list-style: circle;
  margin-left: 2rem;
}
.contenedor_gf{margin-bottom: 8rem;}
@media only screen and (max-device-width : 900px){
    .contenedor_img_cp{display: flex; justify-content: center; margin-bottom: 1rem;}
}
</style>